import React, { Component } from 'react';
import _ from 'lodash';
import { RaisedButton } from 'material-ui';
import EmptyIcon from 'material-ui/svg-icons/social/location-city';
import LocationTile from '../components/LocationTile';
import firebase from '../firebase';
import LinearProgress from "../components/LinearProgress";

const styles = {
  root: {
    padding: 20,
    margin: '0 auto'
  },
  gridList: {
    width: '100%',
    height: '100%',
    overflowY: 'auto',
    display: 'flex',
    flexWrap:'wrap',
  },
};

const LocationsEmpty = ({ onClick }) => (
  <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
    <EmptyIcon style={{ width: 400, height: 400, color: '#afafaf' }}/>
    <h4 style={{ color: '#afafaf'}}>You haven't added any restaurant locations</h4>
    <RaisedButton label="Add a Location" secondary onClick={onClick}/>
  </div>
);

export default class Locations extends Component{
  state = {
    locations: null,
    restaurantId: null,
  };

  async componentDidMount() {
    const { params } = this.props;
    const restaurantId = params.restaurantId;

    if(!restaurantId || restaurantId === '') {
      console.log('No ID');
      return;
    }

    const locationSnaps = await firebase.firestore()
      .collection('restaurant')
      .doc(restaurantId)
      .collection('establishment')
      .get();

    const locations = {};
    locationSnaps.forEach(snap => {
      locations[snap.id] = snap.data();
    });

    this.setState({
      locations,
      restaurantId,
    });
  }

  renderLocations() {
    const { locations, restaurantId } = this.state;

    return _.map(locations, (location, key) => (
      <LocationTile
        location={location}
        style={{ flex: '1 1 200px', marginRight: 15 }}
        onEditPressed={() => this.props.router.push(`/${restaurantId}/edit-location/${key}`)}
      />
    ));
  }

  render() {
    const { locations, restaurantId } = this.state;
    if(!locations) return <LinearProgress />;

    if(_.isEmpty(locations)) return (
      <div style={styles.root}>
        <LocationsEmpty onClick={() => this.props.router.push(`/${restaurantId}/create-location`)} />
      </div>
    );

    return (
      <div style={styles.root}>

        <h1>Locations</h1>
        <RaisedButton
          label="Add Location"
          style={{ marginBottom: 15, }}
          secondary
          onClick={() => this.props.router.push(`/${restaurantId}/create-location`)} />
        <div
          style={styles.gridList}
        >
          {this.renderLocations()}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/Locations.js